import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "applyFunctionOrValue",
})
export class ApplyFunctionOrValue implements PipeTransform {
  transform(_: any, functionOrValue: (...params: unknown[]) => unknown, ...args: unknown[]): unknown {
    if (functionOrValue && typeof functionOrValue === "function") {
      return functionOrValue(...args);
    }
    // if "functionOrValue" is not a function then it is returned
    return functionOrValue;
  }
}
